import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import CssBaseline from '@mui/material/CssBaseline'
import GlobalStyles from '@mui/material/GlobalStyles'

import { store } from '@/store'
import { ThemeProvider } from '@/theme'
import App from '@/App'
import '@/i18n'

// import.meta.env.BASE_URL es '/client-mui/' (o '/' si VITE_BASE='/').
// React Router quiere el basename SIN barra final, salvo que sea '/'.
const baseUrl = import.meta.env.BASE_URL || '/'
const routerBasename = baseUrl === '/' ? '/' : baseUrl.replace(/\/$/, '')

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter basename={routerBasename}>
                <ThemeProvider>
                    <CssBaseline />
                    <GlobalStyles
                        styles={(theme) => {
                            const isDark = theme.palette.mode === 'dark'
                            const thumb = isDark ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.22)'
                            const thumbHover = isDark
                                ? 'rgba(255,255,255,0.32)'
                                : 'rgba(0,0,0,0.38)'
                            return {
                                'html, body, #root': {
                                    overflowX: 'clip',
                                    maxWidth: '100vw'
                                },
                                // Firefox
                                '*': {
                                    scrollbarWidth: 'thin',
                                    scrollbarColor: `${thumb} transparent`
                                },
                                // Chromium/Safari
                                '*::-webkit-scrollbar': { width: 6, height: 6 },
                                '*::-webkit-scrollbar-track': { background: 'transparent' },
                                '*::-webkit-scrollbar-thumb': {
                                    background: thumb,
                                    borderRadius: 4
                                },
                                '*::-webkit-scrollbar-thumb:hover': {
                                    background: thumbHover
                                }
                            }
                        }}
                    />
                    <App />
                </ThemeProvider>
            </BrowserRouter>
        </Provider>
    </React.StrictMode>
)
